import { render, staticRenderFns } from "./BeneficiariesTable.vue?vue&type=template&id=1477a83c&scoped=true"
import script from "./BeneficiariesTable.vue?vue&type=script&lang=js"
export * from "./BeneficiariesTable.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=1477a83c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1477a83c",
  null
  
)

export default component.exports